import {put, takeLatest, all, select} from 'redux-saga/effects';
import {
  LOGOUT,
  API_URL,
  LOAD_USER,
  UPDATE_PROFILE,
  UPDATE_PASSWORD,
  REQUEST_API_KEY,
  TOGGLE_MEMBER,
  ADD_MEMBER,
  UPDATE_MEMBER,
  UPLOAD_LOGO,
} from './constants';
import {GET_AGENT_MEMBERS} from "../Profile/constants";
import {
  setUser,
  loginError,
  profileUpdatedError,
  passwordUpdated,
  passwordUpdatedError,
  setLoading,
  apiKeyReceived,
  apiKeyFailed,
  addMemberFailed,
  updateMemberFailed,
  uploadLogoSuccess,
  uploadLogoFailed,
  toggleMemberFailed,
  toggleMemberSuccess,
  loadedMembers,
} from './actions';
import { selectIsLoading } from './selectors';
import {
  removeAuthToken,
  getPlainRequestHeadersAsLogged,
  getRequestHeadersAsLogged,
  responseHandler
} from '../../utils/auth';

var fetched = false;

function* fetchUser() {
  if (!fetched) {
    fetched = true;
    const requestURL = `${API_URL}agent/profile`;

    try {
      const parameters = {
        method: 'GET',
        headers: getRequestHeadersAsLogged(),
      };

      const response = yield fetch(requestURL, parameters).then(response => {
        if (response.status >= 400 && response.status < 500) {
          throw response.status;
        }
        return responseHandler(response);
      });

      yield put(setUser(response.data));
    } catch (err) {
      console.error('errore', err)
      removeAuthToken();
      yield put(loginError());
      window.location = '/login';
    }
  }
}

function* logout() {
  const requestURL = `${API_URL}logout`;

  try {
    const parameters = {
      method: 'POST',
      headers: getRequestHeadersAsLogged(),
    };

    yield fetch(requestURL, parameters).then(response => {
      if (response.status >= 400 && response.status < 500) {
        throw response.status;
      }
      return responseHandler(response);
    });

    if (window.BE_API) {
      window.BE_API.destroy();
    }

    removeAuthToken();

    if (response.status === 302) {
      window.location = response.headers.get('Location');
    } else {
      window.location = '/login';
    }
  } catch (err) {
    removeAuthToken();
    yield put(loginError());
  }
}

function* updateProfile({profile}) {
  const isLoading = yield select(selectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));

    const requestURL = `${API_URL}agent/profile`;
    const requestBody = {...profile};

    try {
      const parameters = {
        method: 'PUT',
        headers: getRequestHeadersAsLogged(),
        body: JSON.stringify(requestBody),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      const errors = getErrorsFromResponse(response, 'profile');

      if (errors !== false) {
        yield put(profileUpdatedError(errors));
      } else {
        yield put(setUser(response.data));
      }
    } catch (e) {
    }
  }
}

function* updatePassword({passwords}) {
  const isLoading = yield select(selectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));

    const requestURL = `${API_URL}password`;
    const requestBody = {...passwords};

    try {
      const parameters = {
        method: 'PATCH',
        headers: getRequestHeadersAsLogged(),
        body: JSON.stringify(requestBody),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      const errors = getErrorsFromResponse(response, 'password');

      if (errors !== false) {
        yield put(passwordUpdatedError(errors));
      } else {
        yield put(passwordUpdated(response.data));
      }
    } catch (e) {
    }
  }
}

function* requestApiKey() {
  const isLoading = yield select(selectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));

    const requestURL = `${API_URL}agent/service/api`;

    try {
      const parameters = {
        method: 'POST',
        headers: getRequestHeadersAsLogged(),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      const errors = getErrorsFromResponse(response, 'apiKey');

      if (errors !== false) {
        yield put(apiKeyFailed(errors));
      } else {
        yield put(apiKeyReceived(response.data));
      }
    } catch (e) {
      console.error(e)
      yield put(apiKeyFailed('Si sono verificati errori, si prega di riprovare'));
    }
  }
}

function* addMember({agent}) {
  const isLoading = yield select(selectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));

    const requestURL = `${API_URL}agent`;

    try {
      const parameters = {
        method: 'POST',
        headers: getRequestHeadersAsLogged(),
        body: JSON.stringify(agent),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      const errors = getErrorsFromResponse(response, 'member');

      if (errors !== false) {
        yield put(addMemberFailed(errors));
        yield put(setLoading(false));
      } else {
        // yield put(addMemberSuccess(response.data));
        window.location.reload();
      }
    } catch (e) {
    }
  }
}

function* updateMember({agent}) {
  const isLoading = yield select(selectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));

    const requestURL = `${API_URL}agent/${agent.code}`;

    try {
      const parameters = {
        method: 'PUT',
        headers: getRequestHeadersAsLogged(),
        body: JSON.stringify(agent),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      const errors = getErrorsFromResponse(response, 'member');

      if (errors !== false) {
        yield put(updateMemberFailed(errors));
        yield put(setLoading(false));
      } else {
        // yield put(updateMemberSuccess(response.data));
        window.location.reload();
      }
    } catch (e) {
    }
  }
}

function* uploadLogo({file}) {
  const isLoading = yield select(selectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));

    const requestURL = `${API_URL}agent/logo`;

    const formData = new FormData();
    formData.append('logo', file);

    try {
      const parameters = {
        method: 'POST',
        headers: getPlainRequestHeadersAsLogged(),
        body: formData,
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      const errors = getErrorsFromResponse(response, 'rebrand');

      if (errors !== false) {
        yield put(uploadLogoFailed(errors));
      } else {
        yield put(uploadLogoSuccess(response.data));
      }
    } catch (e) {
    }
  }
}

function* toggleMember({agentId}) {
  const isLoading = yield select(selectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));

    const requestURL = `${API_URL}agent/${agentId}/toggle`;

    try {
      const parameters = {
        method: 'PATCH',
        headers: getRequestHeadersAsLogged(),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      const errors = getErrorsFromResponse(response, 'toggleMember');

      if (errors !== false) {
        yield put(toggleMemberFailed(errors));
      } else {
        yield put(toggleMemberSuccess(response.data));
      }
    } catch (e) {
    }
  }
}

function* fetchAgentMembers() {
  const isLoading = yield select(selectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));
    const requestURL = `${API_URL}agent/members`;

    try {
      yield put(setLoading(true));

      const parameters = {
        method: 'GET',
        headers: getRequestHeadersAsLogged(),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      yield put(loadedMembers(response.data));
    } catch (e) {
      console.log('error', e);
    }
  }
}

function getErrorsFromResponse(response, key) {
  if (typeof response.errors !== 'undefined' || typeof response.error !== 'undefined') {
    if (response.error && response.error.http_code) {
      response.errors = response.errors || {};
      response.errors[key] = response.error.http_code < 500 ? [response.error.message || 'Richiesta non valida'] : ['Si sono verificati errori, si prega di riprovare'];
    }
    return {[key]: {...response.errors || {}}};
  }

  return false;
}

function* actionWatcher() {
  yield takeLatest(LOGOUT, logout);
  yield takeLatest(LOAD_USER, fetchUser);
  yield takeLatest(UPDATE_PROFILE, updateProfile);
  yield takeLatest(UPDATE_PASSWORD, updatePassword);
  yield takeLatest(REQUEST_API_KEY, requestApiKey);
  yield takeLatest(ADD_MEMBER, addMember);
  yield takeLatest(UPDATE_MEMBER, updateMember);
  yield takeLatest(UPLOAD_LOGO, uploadLogo);
  yield takeLatest(TOGGLE_MEMBER, toggleMember);
  yield takeLatest(GET_AGENT_MEMBERS, fetchAgentMembers);

}

export default function* appWatcher() {
  yield all([actionWatcher()]);
}
